// @ts-nocheck
import ReactDOM from "react-dom/client";
import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import { App } from "src/app";
import { bootstrapAnalyticsConsent } from "src/libs/analytics";
import "./i18n";

bootstrapAnalyticsConsent();

window.addEventListener("error", function (event) {
  event.preventDefault(); // Prevents the default browser error handler
  console.error(
    "Global error handler:",
    event.message,
    event.filename,
    event.lineno,
    event.colno,
    event.error
  );
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
